export default __webpack_public_path__ + "static/media/uncleDunkelsDesktop.1e3adf1a.jpg";